import { FilterableField } from 'components/organisms/tasks/fields';

export const removeTrailingDots = (text: string): string =>
  text.lastIndexOf('…') === text.length - 1 ? text.replace('…', '') : text;

export const getFieldPathForConditionalVariable = (field: FilterableField) => {
  const { fieldName, fieldId, customField } = field;

  return customField
    ? `project.conditionalCustomField.${fieldId}`
    : fieldName === 'projectOwner'
    ? 'project.owner.userId'
    : `project.${fieldName}`;
};
